import SuggestEditSuccessResponse from './SuggestEditSuccessResponse';

export default SuggestEditSuccessResponse;
